//
// Scroll To Top
//

let scrollTopAbort = null;

export const initScrollToTop = () => {
  if (scrollTopAbort) {
    scrollTopAbort.abort();
  }

  scrollTopAbort = new AbortController();
  const { signal } = scrollTopAbort;

  document.querySelectorAll(".goto-top").forEach(($el) => {
    $el.addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      { signal }
    );
  });

  window.addEventListener(
    "scroll",
    () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      document.querySelectorAll(".goto-top").forEach(($el) => {
        $el.classList.toggle("goto-top--visible", st > 100);
      });
    },
    { signal, passive: true }
  );
};

initScrollToTop();
